
class Share {
    constructor() {
        this.toggleShare = $('.share-toggle-button');
        this.shareContent = $('.share-buttons');

        this.toggleShare.on('click', event => this.toggleButtons(event));
    }

    toggleButtons(e) {
        e.preventDefault();

        this.shareContent.toggleClass('open');
        this.toggleShare.toggleClass('open');
    }

}

export default Share;